// src/components/PieChart.js
import { useRef } from "react";
import { Chart as Chartjs, registerables } from 'chart.js';
import { Bar, Chart } from "react-chartjs-2";
import { getRelativePosition } from 'chart.js/helpers';
import PropTypes from "prop-types";
import moment from "moment";
import 'chartjs-adapter-moment';
import zoomPlugin from "chartjs-plugin-zoom";
import data from "components/Maps/HeatMap/data";

Chartjs.register(...registerables);
Chartjs.register(zoomPlugin); // REGISTER PLUGIN

var timeout, current_chart;
var scroll_event_happening = false;

function ColumnChart({ chartData = [], startTime, endTime, groupSize, setStartTime, setEndTime }) {

  const chartRef = useRef(null);

  const options = {
    layout: {
      padding: 8
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 0
    },
    interaction: {
      mode: 'index',
      intersect: false
    },
    plugins: {
      zoom: {
        limits: {
          x: {
            min: 0,
            max: moment().unix() * 1000,
            minRange: 16000 * 1000,
          }
        },
        title: {
          display: false,
          //   text: field.label
        },
        tooltip: {
          enabled: true,
        }
      },
      legend: {
        onClick: (e, legendItem, legend) => {
          const index = legendItem.datasetIndex;
          const ci = legend.chart;

          if (ci.isDatasetVisible(index)) {
            ci.hide(index);
            legendItem.hidden = true;
          } else {
            ci.show(index);
            legendItem.hidden = false;
          }

          // Force Chart.js to recalculate all scales and redrawing
          ci.update('none');
        },
        position: 'top'
      }
    },
    scales: {
      y: {
        type: 'linear',
        position: 'left',
        stacked: true, // Bars stack vertically
        beginAtZero: true,
        afterDataLimits: (scale) => {
          const chart = scale.chart;
          const datasets = chart.data.datasets;
          let globalMax = 0;

          // 1. Create a map to store the total height for every X timestamp
          const stackTotals = {};

          datasets.forEach((dataset, i) => {
            if (chart.isDatasetVisible(i)) {
              if (dataset.type === 'bar') {
                // Add bar values to their specific X-axis "bucket"
                dataset.data.forEach((point) => {
                  const xVal = point.x;
                  const yVal = point.y || 0;
                  stackTotals[xVal] = (stackTotals[xVal] || 0) + yVal;
                });
              } else if (dataset.type === 'line') {
                // Lines aren't stacked, so we just compare individual points
                dataset.data.forEach((point) => {
                  if (point.y > globalMax) globalMax = point.y;
                });
              }
            }
          });

          // 2. Find the highest stacked bar total
          const maxBarStack = Math.max(...Object.values(stackTotals), 0);

          // 3. Final Comparison: Highest Bar Stack vs. Highest Line Point
          globalMax = Math.max(globalMax, maxBarStack);

          // 4. Set the scale with breathing room (10%)
          // If everything is hidden, default to 10
          scale.max = globalMax > 0 ? globalMax * 1.1 : 10;
        },
      },
      y1: {
        type: 'linear',
        position: 'right',
        stacked: false, // Lines do NOT stack
        beginAtZero: true,
        display: false,
        afterDataLimits: (scale) => {
          scale.max = scale.chart.scales.y.max;
          scale.min = scale.chart.scales.y.min;
        },
        grid: {
          drawOnChartArea: false, // Clean UI
        },
      },
      x: {
        stacked: true,
        type: 'time',
        min: startTime,
        max: endTime,
        time: {
          unit: 'day',
          displayFormats: {
            day: 'DD/MM'
          }
        },
      }
    }
  };

  var chart = (
    <Bar
      ref={chartRef}
      data={chartData}
      options={options}
      style={{ minHeight: '200px', width: 'auto' }}
    />
  )

  console.log(chartData, options)

  return chart;
};

// Typechecking props for the ColumnChart
ColumnChart.propTypes = {
  chartData: PropTypes.object,
  startTime: PropTypes.instanceOf(moment()),
  setStartTime: PropTypes.func,
  endTime: PropTypes.instanceOf(moment()),
  setEndTime: PropTypes.func,
  groupSize: PropTypes.number,
};


export default ColumnChart;